import { render } from "./RulesDetail.vue?vue&type=template&id=74fed5d7&scoped=true"
import script from "./RulesDetail.vue?vue&type=script&lang=js"
export * from "./RulesDetail.vue?vue&type=script&lang=js"

import "./RulesDetail.vue?vue&type=style&index=0&id=74fed5d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74fed5d7"]])

export default __exports__